import {ActionList} from '@primer/react'
import {FailureDialog} from '../FailureDialog'
import {StateIcon} from '../StateIcon'
import type {DefaultError, UseMutationResult} from '@github-ui/react-query'
import {announce} from '@github-ui/aria-live'
import {useReopenPullRequestMutation} from '@github-ui/mergebox/use-reopen-pull-request-mutation'
import {useOptimisticPrStateCallbacks} from '../../hooks/use-invalidate-pr-state'

const mutateOptions = {onSuccess: () => announce('Pull request reopened')}

export function useReopenActionMutation() {
  return useReopenPullRequestMutation(useOptimisticPrStateCallbacks('OPEN'))
}

export function ReopenAction({mutation}: {mutation: UseMutationResult<void, DefaultError, void>}) {
  return (
    <ActionList.Item loading={mutation.isPending} onSelect={() => mutation.mutate(undefined, mutateOptions)}>
      <ActionList.LeadingVisual>
        <StateIcon state="OPEN" />
      </ActionList.LeadingVisual>
      Reopen pull request
    </ActionList.Item>
  )
}

export function ReopenFailureDialog({mutation}: {mutation: UseMutationResult<void, DefaultError, void>}) {
  return mutation.isError ? (
    <FailureDialog
      title="Failed to reopen pull request"
      message="An error occurred while reopening this pull request. Please try again."
      details={mutation.error.message}
      onRetry={() => mutation.mutate(undefined, mutateOptions)}
      onDismiss={() => mutation.reset()}
    />
  ) : null
}
